module.exports = __webpack_public_path__ + "images/111_320.jpg";